import React from "react";

const WelcomePlaceholder: React.FC = () => {
  return (
    <div className="flex flex-col justify-center items-center w-full max-w-3xl h-auto min-h-[400px] md:min-h-[500px] mx-auto mt-4 md:mt-8 text-center rounded-lg p-4 md:p-6">
      <h1 className="text-2xl sm:text-3xl font-bold mb-3 md:mb-4">Welcome!</h1>
      <ul className="list-disc text-base sm:text-lg md:text-xl text-left space-y-1 md:space-y-2 px-4 sm:px-6">
        <li>Explore our <b>CATEGORIES</b> to find exactly what you're looking for.</li>
        <li>Check out our featured <b>PRODUCTS</b> for the latest trends.</li>
        <li>Need help? Reach out to our friendly support team anytime.</li>
      </ul>
      <h2 className="text-lg sm:text-xl font-bold mt-3 md:mt-4">Get started now!</h2>
      <p className="text-sm sm:text-base italic mt-1 md:mt-2 max-w-md mx-auto">
        <b>NOTE:- You should go to the settings page and add the CATEGORIES or PRODUCTS.</b>
      </p>
    </div>
  );
};

export default WelcomePlaceholder;